// extracted by mini-css-extract-plugin
module.exports = {"flash":"Flash_flash__2EAUp","tight":"Flash_tight__hIcgH","info":"Flash_info__3HbTW","warning":"Flash_warning__G0c__","error":"Flash_error__kUO6n","success":"Flash_success__7BWCX"};